<template>
  <div>
    <vx-card class="mb-4">
      <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
        <p>{{newsletterTitle}}</p>
      </b-card-title>

      <div class="w-full flex gap-2 justify-end no-print">
        <b-button
          variant="outline-primary"
          class="float-right"
          @click="getReport">
          <feather-icon
            icon="FileTextIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('action.generate_report')}}</span>
        </b-button>
        <b-button
          variant="outline-secondary"
          class="float-right"
          @click="goBack">
          <feather-icon
            icon="CornerUpLeftIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('back')}}</span>
        </b-button>
      </div>

      <div class="w-full flex gap-2 justify-end pt-2 pb-1">
        <p>{{ $t('total_items') }}: {{ totalSignaturesCount }}</p>
      </div>
      <b-table
        :items="signatures"
        :fields="fieldsDataTable"
        striped
        hover
        caption-top
        responsive="sm">

        <template #cell(signed_at)="{item: {signed_at}}">
          <span>{{ $utils.format.date(signed_at) }}</span>
        </template>
      </b-table>
      <div v-if="signatures.length === 0" class="text-center">
        <p>{{ $t('newsletter.no_signatures_found') }}</p>
      </div>

      <scroll-to-top />
    </vx-card>
  </div>
</template>

<script>

import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BIconClipboard,
  VBTooltip,
  BTable,
} from 'bootstrap-vue'

import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

import NewsletterService from '@/services/api/NewsletterService'


export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BIconClipboard,
    BTable,
    ScrollToTop,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    newsletter: null,
    signatures: [],
  }),
  computed: {
    newsletterTitle() {
      return this.newsletter? this.newsletter.title : ''
    },
    fieldsDataTable() {
      return [
        {key: 'legal_entity.name', sortable: true, label: this.$t('legal_entities_unit')},
        {key: 'name', sortable: true, label: this.$t('newsletter.signature_name')},
        {key: 'email', sortable: true, label: this.$t('newsletter.signature_email')},
        {key: 'signed_at', sortable: true, label: this.$t('newsletter.signature_signed_at')},
      ]
    },
    totalSignaturesCount() {
      return this.signatures.length
    }
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.service = NewsletterService.build(this.$vs)

    //promisses.push()

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })

  },
  mounted() {
    if (this.id) {
      this.loadData()
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  },
  methods: {
    goBack() {
      this.$router.push('/newsletters')
    },
    isAdmin() {
      return isAdmin()
    },
    loadData() {
      this.$vs.loading()
      this.service.getSignatures(this.id).then(response => {
        this.newsletter = response
        this.signatures = response.signatures
      })
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    getReport() {
      this.$vs.loading()
      const title = 'Relatório de assinaturas - '+this.newsletter.title
      this.service.generateReportSignatures(this.id, title).then(response => {
        console.log(response)
        this.notifySuccess(this.$vs, 'Relatório de assinaturas gerado com sucesso. Processando download...', 5000)
      }, error => {
        console.log(error)
        this.notifyError(this.$vs, 'Erro ao gerar relatório de assinaturas.', 5000)
      })
      .finally(() => {
        this.$vs.loading.close()
      })
    }
  }
}
</script>

<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
</style>

